import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';

@Pipe({
  name: 'joiner'
})
export class JoinerPipe implements PipeTransform {
  transform(first: string, separator: string, ...rest: string[]) {
    if (StringHelper.isEmpty(separator)) {
      throw new Error('separator cannot be null or empty');
    }
    return StringHelper.join(
      [first, StringHelper.join(rest, separator)],
      separator
    );
  }
}
